/**
 * Onglets de l'écran Abonnements (`06` §8), portés par `?view=`. **Seule
 * source de vérité** de la liste : la route (`routes/abonnements.tsx`) en
 * dérive son `validateSearch`, la page son `TabsList`. Un lot qui livre un
 * onglet l'ajoute ici, à sa place dans l'ordre de `06` §8 (Paiements échoués,
 * Cantons suisses, Migrations legacy, Exports, Klaviyo, Webhooks), puis branche son
 * composant dans `SUBSCRIPTION_TAB_COMPONENTS` (`subscriptions-page.tsx`) : le
 * typage y impose un composant par vue.
 *
 * Le premier onglet de la liste est l'onglet par défaut.
 */
export const SUBSCRIPTION_VIEWS = ['paiements', 'cantons', 'migrations', 'exports', 'klaviyo', 'webhooks'] as const;

export type SubscriptionView = (typeof SUBSCRIPTION_VIEWS)[number];

export const DEFAULT_SUBSCRIPTION_VIEW: SubscriptionView = SUBSCRIPTION_VIEWS[0];

export const SUBSCRIPTION_VIEW_LABELS: Readonly<Record<SubscriptionView, string>> = {
  paiements: 'Paiements échoués',
  cantons: 'Cantons suisses',
  migrations: 'Migrations legacy',
  exports: 'Exports',
  klaviyo: 'Klaviyo',
  webhooks: 'Webhooks',
};

export function isSubscriptionView(value: unknown): value is SubscriptionView {
  return typeof value === 'string' && (SUBSCRIPTION_VIEWS as readonly string[]).includes(value);
}

/** Lit l'onglet depuis `useSearch({strict:false})` ; inconnu ou absent = onglet par défaut. */
export function readSubscriptionView(rawSearch: unknown): SubscriptionView {
  const view =
    typeof rawSearch === 'object' && rawSearch !== null
      ? (rawSearch as Record<string, unknown>).view
      : undefined;
  return isSubscriptionView(view) ? view : DEFAULT_SUBSCRIPTION_VIEW;
}
